var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 13.7143,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2019 25.7971V42.7738C72.2019 43.7524 71.4086 44.5457 70.43 44.5457H57.7367C56.7581 44.5457 55.9648 43.7524 55.9648 42.7738V22.8995C55.9648 21.9209 56.7581 21.1276 57.7367 21.1276H67.1433M72.2019 25.7971H68.9151C67.9366 25.7971 67.1433 25.0038 67.1433 24.0252V21.1276M72.2019 25.7971L67.1433 21.1276M58.8656 25.7971H64.1718M58.8656 32.5183H68.5936M58.8656 39.2041H68.5936",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2292 55.3413V72.3181C39.2292 73.2967 38.4359 74.09 37.4573 74.09H24.7641C23.7855 74.09 22.9922 73.2967 22.9922 72.3181V52.4437C22.9922 51.4652 23.7855 50.6719 24.7641 50.6719H34.1706M39.2292 55.3413H35.9425C34.9639 55.3413 34.1706 54.5481 34.1706 53.5695V50.6719M39.2292 55.3413L34.1706 50.6719M25.8929 55.3413H31.1991M25.8929 62.0626H35.621M25.8929 68.7484H35.621",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7428 26.343V26.1593C27.7428 23.2516 30.1 20.8945 33.0076 20.8945H33.1913C36.2004 20.8945 38.6398 23.3339 38.6398 26.343C38.6398 29.3521 36.2004 31.7915 33.1913 31.7915C30.1822 31.7915 27.7428 29.3521 27.7428 26.343Z",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3315 44.4271H26.6903C24.6479 44.4271 22.9922 42.7714 22.9922 40.729C22.9922 39.6065 23.3378 38.5113 23.9821 37.5922L24.7982 36.4281L25.1368 36.019C26.0979 34.8576 27.3226 33.9427 28.7088 33.3503C30.0164 32.7915 31.4237 32.5034 32.8457 32.5034H33.4964C34.747 32.5034 35.9881 32.721 37.1641 33.1463C38.9028 33.7752 40.4254 34.8883 41.5522 36.3542L41.609 36.4281L42.349 37.6495C42.8861 38.5358 43.17 39.5523 43.17 40.5886C43.17 42.7086 41.4514 44.4271 39.3315 44.4271Z",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7465 56.0059V55.8222C56.7465 52.9145 59.1036 50.5574 62.0113 50.5574H62.195C65.2041 50.5574 67.6435 52.9968 67.6435 56.0059C67.6435 59.015 65.2041 61.4544 62.195 61.4544C59.1858 61.4544 56.7465 59.015 56.7465 56.0059Z",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3352 74.09H55.694C53.6516 74.09 51.9958 72.4343 51.9958 70.3919C51.9958 69.2694 52.3415 68.1742 52.9858 67.2551L53.8019 66.091L54.1405 65.6819C55.1016 64.5205 56.3263 63.6056 57.7125 63.0132C59.0201 62.4544 60.4273 62.1663 61.8493 62.1663H62.5001C63.7507 62.1663 64.9917 62.3839 66.1678 62.8092C67.9065 63.4381 69.429 64.5512 70.5559 66.0171L70.6127 66.091L71.3527 67.3124C71.8897 68.1987 72.1737 69.2152 72.1737 70.2515C72.1737 72.3715 70.4551 74.09 68.3352 74.09Z",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3212 29.3346H44.1497M44.1497 29.3346L46.5198 26.9645M44.1497 29.3346L46.5198 31.7047",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.17 58.948H51.3416M51.3416 58.948L48.9715 56.5779M51.3416 58.948L48.9715 61.3181",
    stroke: "#008CB7",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCard2);
export default __webpack_public_path__ + "static/media/ProductCard2.ce02f9a9255d3a74966beaf7da1062af.svg";
export { ForwardRef as ReactComponent };